import Form from "@/classes/Form";
import {route} from "@/functions/route";
import {httpClient} from "@/httpClients/httpClient";
import crud from "@/stores/crud";

const getDefaultState = () => {
	return {
		...crud.state,
		routes: {
			index: (parameters) => {
				return "service-providers/" + window.app.$router.currentRoute.params.serviceProvider + "/users";
			},
			show: (parameters) => {
				return "service-providers/" + window.app.$router.currentRoute.params.serviceProvider + "/users/:user";
			},
			sendPortalEmail: "service-providers/:serviceProvider/users/:user/send-portal-email",
		},
		sendPortalEmailForm: new Form({}, httpClient),
	};
};

const state = getDefaultState();

export default {
	namespaced: true,
	state,
	actions: {
		...crud.actions,
		sendPortalEmail({state}, user) {
			return state.sendPortalEmailForm.delayResponse(1000).post(route(state.routes.sendPortalEmail, [
				window.app.$router.currentRoute.params.serviceProvider,
				user,
			]));
		},
	},
	mutations: {
		...crud.mutations,
	},
	getters: {
		...crud.getters,
	},
};
